import React, {useState} from 'react'
import {
  Card, CardHeader, Row, Col, Badge, CardBody
} from 'reactstrap'
import { Doughnut } from 'react-chartjs-2'
import Monetario from '../Monetario'
import colorChats from '../../lib/colorChats'

const PizzaQtde = ({ title, color, dados }) => {

  const [totalGrafico, setTotalGrafico] = useState(dados.total)

  const options = {
    legend: {
      display: true,
      position: "left",
      labels: {
        usePointStyle: true,
        pointStyle: 'circle',
        boxWidth: 8,
        padding: 5,
      },
    },
    tooltips: {
      enabled: true,
      callbacks: {
        label: function(tooltipItem, data) {
          // var label = data.datasets[0].labels[tooltipItem.index] || '';
        //   var label = parseFloat(data.datasets[0].data[tooltipItem.index]).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) || 'R$ 00,00'
        var label = data.datasets[0].data[tooltipItem.index];
        
          var dataset = data.datasets[tooltipItem.datasetIndex];
          var meta = dataset._meta[Object.keys(dataset._meta)[0]];
          var total = meta.total;

          setTotalGrafico(total)

          var valor = dataset.data[tooltipItem.index];
          var porcentagem = parseFloat((valor/total*100).toFixed(1));
          label += ' ('+porcentagem+'%)';

          return label;
        },
        title: function(tooltipItem, data) {
          return data.labels[tooltipItem[0].index];
        },
        // afterLabel: function(tooltipItem, data) {
        //   console.log('teste after');
        //   var dataset = data.datasets[tooltipItem.datasetIndex];
        //   var meta = dataset._meta[Object.keys(dataset._meta)[0]];

        //   var percent = Math.round((dataset.data[tooltipItem.index] / meta.total) * 100)
        //   return '(' + percent + '%)';

        // },
      }
    },
    scales: {
      yAxes: [
        {
          ticks: {
            display: false
          },
          gridLines: {
            drawBorder: false,
            zeroLineColor: "transparent",
            color: "rgba(255,255,255,0.05)"
          }
        }
      ],
      xAxes: [
        {
          barPercentage: 1.6,
          gridLines: {
            drawBorder: false,
            color: "rgba(255,255,255,0.1)",
            zeroLineColor: "transparent"
          },
          ticks: {
            display: false
          }
        }
      ]
    },
    // onClick: (e, activeEls) => {function(tooltipItem, data) {
    // onClick: (event) => {

    //   console.log(event.chart);

    //   // let datasetindex = activeEls.datasets;
    //   // console.log(activeEls);
    //   // console.log(e);
    //   // let datasetIndex = activeEls[0].datasetIndex;
    //   // let dataIndex = activeEls[0].index;
    //   // let datasetLabel = e.chart.data.datasets[datasetIndex].label;
    //   // let value = e.chart.data.datasets[datasetIndex].data[dataIndex];
    //   // let label = e.chart.data.labels[dataIndex];
    //   // console.log("In click", datasetLabel, label, value);
    // }
  }

  const data = {
    labels: dados.lojas,
    datasets: [
      {
        labels: dados.lojas,
        pointRadius: "0",
        pointHoverRadius: "0",
        backgroundColor: colorChats.vivida,
        borderWidth: "0",
        data: dados.valores
      }
    ],
    hoverOffset: 10
  }

  return (
    <Card className='mb-0 mt-2'>
      <CardHeader>
        <Row>
          <Col sm="7">
            <div className="numbers pull-left grafico-valor"><Monetario valor={totalGrafico}/></div>
          </Col>
          <Col sm="5">
            <div className="pull-right">
              <Badge className={color} pill>
                {title}
              </Badge>
            </div>
          </Col>
        </Row>
      </CardHeader>
      <CardBody>
        <Doughnut
          data={data}
          options={options}
          width={550}
          height={250}
        />
      </CardBody>
    </Card>
  )
}

export default PizzaQtde